import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useSetShipmentItemPackstation, type PurchaseShipmentItem } from "@/api/purchase";
import { fehlerText } from "@/lib/fehlerText";

/** Packstation-Direktanteil einer Container-Position; gemeinsam fuer Reiter Container und Arbeitsplatz. */
export function PackstationAnteil({ item, stern, locked }: { item: PurchaseShipmentItem; stern: string; locked: boolean }) {
  const mutation = useSetShipmentItemPackstation(item.id);
  const [draft, setDraft] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const d = item.packstation_kartons ?? 0;
  const value = draft ?? String(d);
  const kartons = Number(value);
  const valid = value !== '' && Number.isInteger(kartons) && kartons >= 0 && kartons <= (item.cartons ?? 0);
  const directPieces = d === 0 ? 0 : item.pieces_per_carton == null ? null : Math.min(d * item.pieces_per_carton, item.qty);
  async function save() {
    if (locked || mutation.isPending || !valid) return;
    setError(null);
    try {
      await mutation.mutateAsync({ kartons });
      setDraft(null);
      toast.success('Packstation-Anteil gespeichert');
    } catch (e) { setError(fehlerText(e, 'Packstation-Anteil konnte nicht gespeichert werden')); }
  }
  return <div className="rounded-lg border border-line p-3 text-xs space-y-2">
    <div className="font-medium">{stern}</div>
    <div className="flex flex-wrap gap-x-5 gap-y-1">
      <span>Packstation: {d} Kartons · {directPieces ?? 'unbekannt'} St.</span>
      <span>Auf Paletten: {item.cartons == null ? 'unbekannt' : item.cartons - d} Kartons · {directPieces == null ? 'unbekannt' : item.qty - directPieces} St.</span>
    </div>
    <div className="flex flex-wrap items-end gap-2">
      <label className="text-ink-2" htmlFor={`packstation-${item.id}`}>Kartons → Packstation
        <Input id={`packstation-${item.id}`} aria-label={`Kartons → Packstation für ${stern}`} type="number"
          min={0} max={item.cartons ?? 0} step={1} className="mt-1 h-8 w-24 text-xs" value={value}
          disabled={locked || mutation.isPending} onChange={e => setDraft(e.target.value)} />
      </label>
      <Button size="sm" variant="outline" aria-label={`Packstation-Anteil für ${stern} speichern`}
        disabled={locked || mutation.isPending || !valid} onClick={() => void save()}>
        {mutation.isPending ? 'Speichere…' : 'Packstation-Anteil speichern'}
      </Button>
    </div>
    {locked && <div className="text-ink-2">Packstation-Anteil gesperrt nach Zustellung, Wareneingang oder Archivierung; Bearbeitung braucht Einkaufsrechte.</div>}
    {error && <div role="alert" className="text-red-600 dark:text-red-400">{error}</div>}
  </div>;
}
